/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router';
import PaymentPage from '../containers/PaymentPage';
import ErrorPage from '../containers/ErrorPage';
import LogCannon from '@ace-clublabs/log-cannon';
import { useGlobalState } from '../shared/state';
import { RedirectPage } from '../containers/RedirectPage';
import AutoPayTermsAndConditions from '../containers/AutoPayTermsAndConditions';
import { PaymentDate } from '../containers/PaymentDate';
import { Pages } from '../shared/pages';
import { PaymentMethods } from '../containers/PaymentMethods';
import { ConfirmationPage } from '../containers/ConfirmationPage';
import PaymentRouter from '../containers/PaymentRouter';
import { PayByLink } from '../containers/PayByLink';
import { PayByLinkAuthentication } from '../containers/PayByLinkAuthentication';

const Router: React.FC = () => {
  let location = useLocation();

  useEffect(() => {
    LogCannon.blast(`Navigate to ${location.pathname}`, {
      pathname: location.pathname,
      search: location.search,
    });
  }, [location]);

  const state = {
    customerId: useGlobalState('customerId')[0],
    epcRequestId: useGlobalState('epcRequestId')[0],
    error: useGlobalState('error')[0],
    isMobileApp: useGlobalState('isMobileApp')[0],
    isScheduled: useGlobalState('isScheduled')[0],
    manifest: useGlobalState('manifest')[0],
    manifestId: useGlobalState('manifestId')[0],
    payByLinkData: useGlobalState('payByLinkData')[0],
    paymentMethodsSkipped: useGlobalState('paymentMethodsSkipped')[0],
    paymentType: useGlobalState('paymentType')[0],
    redirectMap: useGlobalState('redirectMap')[0],
    renderAuthorization: useGlobalState('renderAuthorization')[0],
    scheduledDate: useGlobalState('scheduledDate')[0],
    sessionId: useGlobalState('sessionId')[0],
    paymentProcessing: useGlobalState('paymentProcessing')[0],
  };

  useEffect(() => {
    sessionStorage.setItem('paymentsState', JSON.stringify(state));
  }, [state]);

  return (
    <Routes>
      <Route path={Pages.PaymentPage} element={<PaymentPage />} />
      <Route path={Pages.SchedulePayment} element={<PaymentDate />} />
      <Route path={Pages.PaymentMethods} element={<PaymentMethods />} />
      <Route path={Pages.ConfirmationPage} element={<ConfirmationPage />} />
      <Route path={Pages.PayByLinkAuthentication} element={<PayByLinkAuthentication />} />
      <Route path={Pages.PayByLink} element={<PayByLink />} />
      <Route path="/redirect/:id" element={<RedirectPage />} />
      <Route path="/:id" element={<PaymentRouter />} />
      <Route path="/termsandconditions" element={<AutoPayTermsAndConditions />} />
      <Route path={Pages.Error} element={<ErrorPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default Router;
